import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isOpen: false,
    modalType: null, // 'basic' | 'progress'
    modalProps: {
        title: '',
        message: '',
        severity: 'info'
    }
};

const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        openModal: (state, action) => {
            const { modalType, modalProps } = action.payload;
            state.isOpen = true;
            state.modalType = modalType;
            state.modalProps = {
                ...state.modalProps,
                ...modalProps
            };
        },
        closeModal: (state) => {
            state.isOpen = false;
            state.modalType = null;
            state.modalProps = initialState.modalProps;
        }
    }
});

export const { openModal, closeModal } = modalSlice.actions;

// Progress modal action creators
export const showProgressModal = () => openModal({ modalType: 'progress' });
export const hideProgressModal = () => closeModal();

export default modalSlice.reducer; 